module.exports = "/_next/static/images/dish-header-b7c34216864a6a61b06cca1d29a69881.jpg";